const domain_categories = (currency = 'GBP') => ({
    "Popular": currency === 'USD' ? [
        ".com", ".net", ".org",
        ".co", ".info", ".us", ".online",
    ] : [
        ".co.uk", ".com", ".uk", ".org.uk", ".net", ".org",
        ".co", ".info", ".me.uk", ".online",
    ],
    "New": [
        ".green", ".monster", ".garden", ".loan", ".eco",
    ],
    "United Kingdom": [
        ".co.uk", ".uk", ".london", ".scot", ".wales",
        ".cymru", ".uk.com", ".org.uk", ".me.uk",
    ],
    "Geographic": [
        ".co.uk", ".uk", ".country", ".cymru", ".earth",
        ".eu", ".global", ".irish", ".international", ".land",
        ".london", ".me.uk", ".nyc", ".org.uk", ".place",
        ".scot", ".town", ".uk.com", ".wales", ".world",
        ".viajes", ".berlin", ".ltd.uk", ".capetown",
        ".cologne", ".es", ".gb.com", ".gb.net", ".africa",
        ".bayern", ".biz.pl", ".ca", ".at", ".ch", ".com.es",
        ".com.gr", ".com.im", ".com.ph", ".com.pl", ".com.pt",
        ".com.ro", ".dk", ".edu.gr", ".edu.pl", ".eu.com",
        ".fr", ".gg", ".gr", ".hamburg", ".in", ".info.pl",
        ".io", ".it", ".je", ".koeln", ".net.gr", ".net.im",
        ".net.nz", ".net.ph", ".net.pl", ".nl", ".nom.es",
        ".nom.pl", ".nz", ".org.es", ".org.gr", ".org.im",
        ".org.nz", ".org.ph", ".org.pl", ".ph", ".pl", ".ro",
        ".se", ".shop.pl", ".tokyo", ".uk.net", ".vegas",
        ".waw.pl", ".yokohama", ".pt", ".mx", ".is", ".im",
        ".cc", ".co.im", ".co.ma", ".co.nz", ".co.za", ".ac",
        ".ae", ".be", ".ma", ".capital", ".city", ".durban",
        ".joburg", ".nagoya", ".wien", ".au", ".cl",
    ],
    "Business": [
        ".co", ".biz", ".info", ".ltd", ".limited",
        ".business", ".company", ".shop", ".email",
        ".support", ".store", ".agency", ".associates",
        ".auction", ".bargains", ".bid", ".bingo",
        ".boutique", ".build", ".casino", ".center",
        ".cheap", ".cleaning", ".codes", ".consulting",
        ".contractors", ".coupons", ".deals", ".delivery",
        ".design", ".direct", ".directory", ".discount",
        ".enterprises", ".events", ".express", ".farm",
        ".fashion", ".furniture", ".gift", ".gifts",
        ".holdings", ".industries", ".ink", ".jewelry",
        ".legal", ".link", ".management", ".market",
        ".partners", ".parts", ".productions", ".promo",
        ".repair", ".report", ".sale", ".services", ".solar",
        ".solutions", ".supplies", ".supply", ".team",
        ".tools", ".top", ".toys", ".trade",
        ".work", ".zone", ".haus", ".immobilien", ".immo",
        ".luxury", ".pub", ".sarl", ".ruhr", ".ventures",
        ".kaufen",
    ],
    "Education": [
        ".academy", ".college", ".courses", ".degree",
        ".education", ".foundation", ".institute", ".mba",
        ".school", ".study", ".training", ".university",
        ".shiksha", ".schule",
    ],
    "Fashion": [
        ".boutique", ".clothing", ".design", ".fashion",
        ".jewelry", ".salon",
    ],
    "Financial": [
        ".cash", ".claims", ".credit", ".creditcard",
        ".exchange", ".finance", ".financial", ".fund",
        ".gold", ".insure", ".investments", ".loan", ".loans",
        ".money", ".mortgage", ".tax", ".gratis",
    ],
    "Food & Drink": [
        ".bar", ".beer", ".cafe", ".catering", ".coffee",
        ".cooking", ".fish", ".kitchen", ".menu", ".recipes",
        ".restaurant", ".vodka", ".wine", ".kiwi", ".pizza",
        ".pub",
    ],
    "Health": [
        ".care", ".clinic", ".dental", ".fit", ".healthcare",
        ".physio", ".rehab", ".rip", ".surgery", ".doctor",
        ".fun",
    ],
    "Hobbies": [
        ".band", ".club", ".dance", ".dog", ".fitness",
        ".garden", ".horse", ".me", ".photography", ".photos",
        ".pics", ".pictures", ".video", ".wine", ".yoga",
        ".fun", ".games",
    ],
    "Interest": [
        ".guru", ".help", ".yoga", ".xyz", ".dog", ".camera",
        ".cards", ".christmas", ".church", ".community",
        ".diamonds", ".fail", ".faith", ".fans", ".fyi",
        ".garden", ".glass", ".gripe", ".horse", ".lol",
        ".ninja", ".one", ".rocks", ".shoes", ".space",
        ".vote", ".watch", ".win", ".wtf", ".tv", ".tienda",
        ".page",
    ],
    "Lifestyle": [
        ".adult", ".best", ".buzz", ".camp", ".chat",
        ".clothing", ".cool", ".date", ".dating", ".exposed",
        ".family", ".gives", ".group", ".how", ".life",
        ".live", ".love", ".memorial", ".men", ".party",
        ".plus", ".porn", ".rest", ".sex", ".sexy",
        ".singles", ".social", ".style", ".tattoo", ".today",
        ".vip", ".wedding", ".surf", ".jetzt", ".luxury",
        ".moda", ".moe", ".fun", ".name", ".blue", ".pink",
        ".red", ".pro", ".tienda", ".uno", ".black", ".kim",
        ".monster"
    ],
    "Media": [
        ".actor", ".art", ".band", ".dance", ".film",
        ".gallery", ".guide", ".marketing", ".media",
        ".movie", ".news", ".photo", ".photography",
        ".photos", ".pic", ".pictures", ".press", ".review",
        ".reviews", ".show", ".stream", ".theater", ".tips",
        ".tube", ".video", ".webcam", ".wiki", ".tv",
    ],
    "Government": [
        ".airforce", ".army", ".democrat", ".navy",
        ".republican",
    ],
    "Occupations": [
        ".accountant", ".accountants", ".builders",
        ".careers", ".ceo", ".dental", ".dentist",
        ".engineer", ".engineering", ".expert", ".florist",
        ".law", ".lawyer", ".plumbing", ".works", ".attorney",
        ".vet",
    ],
    "Property": [
        ".apartments", ".construction", ".estate", ".forsale",
        ".house", ".lease", ".maison", ".mortgage",
        ".properties", ".rent", ".rentals", ".studio",
        ".immobilien", ".immo", ".haus",
    ],
    "Sport": [
        ".bike", ".cricket", ".fishing", ".fitness",
        ".football", ".futbol", ".golf", ".hockey", ".poker",
        ".racing", ".rodeo", ".run", ".ski", ".soccer",
        ".tennis",
    ],
    "Technology": [
        ".online", ".site", ".website", ".blog", ".tech",
        ".technology", ".email", ".mobi", ".tel", ".bio",
        ".click", ".computer", ".digital", ".domains",
        ".download", ".energy", ".equipment", ".graphics",
        ".host", ".lighting", ".network", ".science",
        ".software", ".systems", ".vision", ".wiki", ".cloud",
        ".hosting", ".mx", ".app", ".archi", ".page", ".dev",
    ],
    "Travel": [
        ".cab", ".coach", ".condos", ".cruises", ".flights",
        ".holiday", ".limo", ".taxi", ".tours", ".vacations",
        ".villas", ".voyage", ".reisen", ".to",
    ],
})